import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const DonationsPage = lazy(() => import('@/pages/donations/ui/DonationsPage'))

export const Route = createFileRoute('/_protected/donations')({
  component: () => (
    <Suspense fallback={<Loader />}>
      <DonationsPage />
    </Suspense>
  ),
})
